import { Icons, LinkBehaviour } from '@cast/design-system';
import { Node } from '@cast/types';

import { Link } from 'components/router';

import {
  useCluster,
  isKentManagedCluster,
} from '@cast/shared-cluster-context-data-access';
import { makeOrgAuditLogLink } from 'features/organization/audit-log/navigation';
import dayjs from 'dayjs';

type Props = {
  node: Node;
};

export const ViewNodeAuditLogsLink = ({ node }: Props) => {
  const { cluster } = useCluster();
  const timezone = dayjs.tz.guess();
  const fromDate = dayjs()?.subtract(12, 'days').toISOString();
  const toDate = dayjs().toISOString();
  // Node autoscaling logs are not supported for Kent managed clusters
  if (isKentManagedCluster(cluster)) {
    return null;
  }

  return (
    <LinkBehaviour
      data-testid="node-details-audit-logs-link"
      component={Link}
      to={makeOrgAuditLogLink({
        clusterId: cluster.id,
        freeText: node.id,
        timezone,
        fromDate,
        toDate,
      })}
      target="_blank"
      display="flex"
      alignItems="center"
      sx={{
        textDecoration: 'none',
      }}
      gap={4}
      variant="P12M"
    >
      View audit logs
      <Icons.ArrowSquareOut size={16} />
    </LinkBehaviour>
  );
};
